<template>
  <div class="page-works-detail">
    <Loading v-if="loading" :count="6"></Loading>
    <el-descriptions v-else :column="1" :colon="false">
      <el-descriptions-item label="作品名称">
        {{ detail.title || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="设计团队">
        {{ detail.teamName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="院校单位">
        {{ detail.institution || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="奖项标签">
        {{ detail.awardLabel || '-' }}
      </el-descriptions-item>
      <!-- <el-descriptions-item label="作品描述">
        {{ detail.description || '-' }}
      </el-descriptions-item> -->
      <el-descriptions-item label="缩略图">
        <el-image
          v-if="detail.thumbnailUrl"
          style="width: 100px; height: 100px"
          :src="detail.thumbnailUrl"
          :preview-src-list="[detail.thumbnailUrl]"
        ></el-image>
        <span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="设计说明">
        {{ detail.designNotes || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="类型">
        {{ detail.type == 1 ? '产品类' : '创意类' }}
      </el-descriptions-item>
      <el-descriptions-item label="年份">
        {{ detail.designNotes || '-' }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import Loading from '@/components/loading'
import { getFileName, saveFile } from '@/utils/tools'

const patentTypeMap = {
  1: '实用专利类型',
  2: '外观设计类型',
  3: '发明专利类型',
  4: '软著/著作类型',
  5: '商标类型'
}

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: true,
      id: this.$route.params.id,
      detail: null,
      patentTypeMap
    }
  },
  mounted() {
    this.fetchDetail()
  },
  methods: {
    getFileName(path) {
      return getFileName(path)
    },
    async fetchDetail() {
      this.loading = true
      const [err, res] = await this.$serve.jsHistoricalWork.info({
        queryId: this.id
      })
      this.loading = false
      if (err) return
      this.detail = res
    },
    download(path) {
      saveFile(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-works-detail {
  ::v-deep {
    .el-descriptions-item__container {
      min-height: 40px;
      line-height: 40px;
    }
    .el-descriptions-item__label {
      width: 120px;
      text-align: right;
    }
  }
}
</style>
